export const dateFormat = (date: string) => {
    return new Intl.DateTimeFormat('en-GB').format(new Date(date)).replace(/\//g, '-');
}

export const dateTimeFormat = (date: string) => {
    const d = new Date(date);
    return d.toLocaleString();
}

export const role = [
    "SuperAdmin",
]

export const validateForm = (config: any[], data: any): string | null => {
    if (!config) return null;
    for (const field of config) {
        if (field.require) {
            const val = data?.[field.key];
            if (val === undefined || val === null || (typeof val === 'string' && val.trim() === '')) {
                return `Field '${field.name}' is mandatory.`;
            }
        }
    }
    return null;
};